import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { HANDS, STAR_BREATHING_VO } from '../config/Config';
import { StarBreathingFollower } from '../display/StarBreathingFollower';
import { StarBreathingTrail } from '../display/StarBreathingTrail';
export class StateStarBreathingIntro extends SceneState {
  startState() {
    const pathConfig = HANDS.elmo;
    this.path = pathConfig.path.map((p, i) => ({
      ...p,
      distance: i == 0 ? 0 : Phaser.Math.Distance.BetweenPoints(pathConfig.path[i - 1], p),
      angle: i == 0 ? 0 : Phaser.Math.Angle.BetweenPoints(pathConfig.path[i - 1], p),
    }));

    this.hand = this.scene.add.image(910, 780, pathConfig.image.sheet, pathConfig.image.key);
    this.hand.setOrigin(0.5, 1);

    this.scene.tweens.add({
      targets: this.hand,
      y: { from: 2000, to: 780 },
      duration: 500,
      onComplete: () => this.playScene(),
    });
  }

  playScene() {
    this.pathTrail = new StarBreathingTrail(this.scene, 0, 0);
    this.waitForVO = true;
    this.scene.game.vo.playChain(STAR_BREATHING_VO.elmo_up, {
      onComplete: this.handleStarVoComplete,
      onCompleteScope: this,
    });
    this.timer = this.scene.time.addEvent({
      delay: 5000,
      callback: () => this.startHandFollow(),
    });
  }

  startHandFollow() {
    this.handPointer = this.scene.add.image(810, 360, 'star_breathing', 'pointer_elmo');
    this.handPointer.setOrigin(0.13, 0.5);
    this.pathFollower = new StarBreathingFollower({
      path: this.path,
      offset: this.hand,
      target: this.handPointer,
      speed: 80,
    });
    this.pathFollower.on('star_reached', this.handleStarReached, this);
  }

  handleStarReached(star) {
    this.currentStar = star;
    if (this.pathFollower.pathComplete) return;
    if (this.waitForVO) {
      this.pathFollower.speed = 0;
      this.resumeStar = true;
    } else {
      if (star == 1) {
        this.pathFollower.speed = 50;
        this.waitForVO = true;
        this.scene.game.vo.playChain(STAR_BREATHING_VO.elmo_down, {
          onComplete: this.handleStarVoComplete,
          onCompleteScope: this,
        });
      } else {
        this.pathFollower.speed = 125;
        const vo = star % 2 == 0 ? STAR_BREATHING_VO.breathe_in : STAR_BREATHING_VO.breathe_out;
        this.scene.game.vo.playChain(vo);
      }
    }
  }

  handleStarVoComplete() {
    this.waitForVO = false;
    if (this.resumeStar) {
      this.resumeStar = false;
      this.handleStarReached(this.currentStar);
    }
  }

  onSceneUpdate(time, delta) {
    if (this.pathTrail) this.pathTrail.update(delta);
    if (this.pathFollower) {
      const { x, y } = this.handPointer;
      this.pathFollower.update(delta);
      this.pathTrail.addPoints({ x, y }, this.handPointer);

      if (this.pathFollower.pathComplete) {
        this.pathFollower = null;
        this.handlePathTweenComplete();
      }
    }
  }
  handlePathTweenComplete() {
    this.scene.tweens.add({
      targets: this.handPointer,
      alpha: 0,
      duration: 100,
    });
    this.scene.tweens.add({
      targets: this.hand,
      y: 2000,
      delay: 500,
      duration: 500,
      onComplete: () => this.emit('state_complete'),
    });
  }

  endState() {
    this.vo = null;
    this.scene.game.vo.stop();
    this.pathFollower = null;
    if (this.timer) {
      this.timer.remove();
      this.timer = null;
    }
    this.removeSceneObject('pathTrail');
    this.removeSceneObject('hand');
    this.removeSceneObject('handPointer');
  }

  removeSceneObject(id) {
    if (this[id]) {
      this.scene.tweens.killTweensOf(this[id]);
      this[id].destroy();
      this[id] = null;
    }
  }
}
